import React from 'react';


class Defaults extends React.Component {
  static propTypes = {
  };

  render() {
    return (
      <div>
      </div>
    );
  }
}

export default Defaults;



/** WEBPACK FOOTER **
 ** ./src/Defaults/Defaults.js
 **/